import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgbCollapseModule, NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ReportCommentModalModule} from '../report-comment-modal/report-comment-modal.module';
import {PipesModule} from '../../pipes/pipes.module';
import {CommentComponent} from './comment.component';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faEllipsisV, faSync, faInfoCircle} from '@fortawesome/free-solid-svg-icons';
import {faThumbsDown, faThumbsUp} from '@fortawesome/free-regular-svg-icons';

@NgModule({
    declarations: [ CommentComponent ],
    imports: [
        RouterModule,
        CommonModule,
        PipesModule,
        NgbDropdownModule,
        FormsModule,
        ReactiveFormsModule,
        ReportCommentModalModule,
        NgbCollapseModule,
        FontAwesomeModule,
        NgbTooltipModule
    ],
    exports: [ CommentComponent ]
})

export class CommentModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faSync, faEllipsisV, faThumbsUp, faThumbsDown, faInfoCircle);
  }
}
